import React from 'react';
import { color } from 'src/utils/mui';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';


const useStyles = makeStyles({
    root: {
        color: color('textPrimary')
    }
});

export const CustomCircularProgress = ({ ...other }) => {
    const { root } = useStyles({});

    return (
        <CircularProgress
            size={30}
            classes={{ root }}
            thickness={3}
            {...other}
        />
    );
};
